var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"is-size-7 has-text-grey"},[_c('p',{staticClass:"has-text-grey is-size-7"},[_c('b-icon',{attrs:{"icon":"info-circle","size":"is-small","type":"is-info"}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }